import { debounce } from 'lodash'

export default {
  name: 'StockFiltersMixins',
  data () {
    return {
      allPrograms: [],
      loadingFilters: false,
      actability: false,
      lotType: [],
      statesFilter: [],
      surfaceFilter: [],
      salePriceFilter: [],
      dateLivraisonFilter: [],
      filters: {
        site_enabled: null,
        diffusion_enabled: null,
        created_on__gte: null,
        created_on__lte: null,
        sale_price_ttc__gte: null,
        sale_price_ttc__lte: null,
        surface__gte: null,
        surface__lte: null,
        tax_dispositifs: [],
        program: null,
        operation_type: [],
        exposures: [],
        date_livraison: [],
        lot_type: [],
        lot_subtype: [],
        date_actabilite__lt: null,
        date_actabilite__gt: null,
        annex_type: [],
        nature: [],
        floor: [],
        nb_face: [],
        sales_mode: [],
        lot__status: [],
        program__status: [],
        state_code: [],
        extern_visibility: null,
        intern_visibility: null,
        location: [],
        distance: null,
        destination: null
      },
      initFilters: {
        site_enabled: null,
        diffusion_enabled: null,
        created_on__gte: null,
        created_on__lte: null,
        sale_price_ttc__gte: null,
        sale_price_ttc__lte: null,
        surface__gte: null,
        surface__lte: null,
        tax_dispositifs: [],
        program: null,
        operation_type: [],
        exposures: [],
        date_livraison: [],
        lot_type: [],
        lot_subtype: [],
        date_actabilite__lt: null,
        date_actabilite__gt: null,
        annex_type: [],
        nature: [],
        floor: [],
        nb_face: [],
        sales_mode: [],
        lot__status: [],
        program__status: [],
        state_code: [],
        extern_visibility: null,
        intern_visibility: null,
        location: [],
        distance: null,
        destination: null
      }
    }
  },
  computed: {
    sortButtons () {
      let buttons = [
        {
          key: 'name',
          sort: 'asc',
          label: 'Nom de A à Z'
        },
        {
          key: 'name',
          sort: 'desc',
          label: 'Nom de Z à A'
        }
      ]
      if ((this.isAdmin || this.isEditor) && this.isPromoteur) {
        buttons.push({
          key: 'created_on',
          sort: 'desc',
          label: 'Date de création la plus récente'
        })
        buttons.push({
          key: 'created_on',
          sort: 'asc',
          label: 'Date de création la plus ancienne'
        })
      }
      return {
        label: 'Trier les programmes par :',
        buttons
      }
    }
  },
  watch: {
    'filters.lot__status' (v) {
      localStorage.setItem('stock_filter_lot__status', JSON.stringify(v))
    },
    'filters.program__status' (v) {
      localStorage.setItem('stock_filter_program__status', JSON.stringify(v))
    }
  },
  methods: {
    /**
     * call before submit getters (filter for example)
     * @return { Object } - processed filters
     */
    beforeSubmit () {
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'stockList', name: key, value: this.filters[key] })
      }
      let filters = Object.assign({}, this.filters)
      // transform filters to return only pk
      Object.keys(filters).forEach((filterKey, i) => {
        let values = Object.values(filters)[i]
        if (Array.isArray(values)) {
          filters[filterKey] = values.map(x => x.pk || x.value || x)
        } else filters[filterKey] = values
      })
      return filters
    },
    beforeResetFilters () {
      this.actability = false
      this.lotType = []
      this.surfaceFilter = []
      this.salePriceFilter = []
      this.dateLivraisonFilter = []
      this.statesFilter = []
    },
    async initFiltersParams () {
      Object.assign(this.filters, this.$route.params)
      await this.$nextTick(async () => {
        this.beforeSubmit()
        await this.updateSimpleFilter()
      })
    },
    async initQueryParams () {
      Object.assign(this.filters, this.$route.query)
      if (this.$route.query.surface__gte || this.$route.query.surface__lte) {
        this.updateSurfaceFilter([
          this.$route.query.surface__gte || null,
          this.$route.query.surface__lte || null
        ])
      }
      if (this.$route.query.sale_price_ttc__gte || this.$route.query.sale_price_ttc__lte) {
        this.updateSalePriceFilter([
          this.$route.query.sale_price_ttc__gte || null,
          this.$route.query.sale_price_ttc__lte || null
        ])
      }
      if (this.$route.query.date_actabilite__lt || this.$route.query.date_actabilite__gt) {
        this.updateActabilityFilter([
          this.$route.query.date_actabilite__lt || null,
          this.$route.query.date_actabilite__gt || null
        ])
      }
      if (this.$route.query.state_code) {
        this.updateStatesFilter(this.$route.query.state_code)
      }
      if (this.$route.query.date_livraison) {
        this.updateDateLivraisonFilter(this.$route.query.date_livraison)
      }
      if (this.$route.query.lot_type && this.$route.query.lot_type.length) {
        let list = this.$route.query.lot_type.slice()
        this.$set(this.filters, 'lot_type', list)
        this.lotType = list
      }
      if (this.isAdmin && this.isPromoteur) {
        if (localStorage.getItem('stock_filter_lot__status')) {
          this.filters.lot__status = JSON.parse(localStorage.getItem('stock_filter_lot__status'))
        }
        if (localStorage.getItem('stock_filter_program__status')) {
          this.filters.program__status = JSON.parse(localStorage.getItem('stock_filter_program__status'))
        }
      }
      if (this.$route.query.promoteur && Array.isArray(this.$route.query.promoteur)) {
        for (let child of this.$route.query.promoteur) {
          if (typeof child === 'string') {
            let promoteur = await this.getPromoteur(child)
            let index = this.filters.promoteur.findIndex(x => x === child)
            this.filters.promoteur.splice(index, 1, promoteur)
          }
        }
      }
      await this.$nextTick(async () => {
        this.beforeSubmit()
        await this.updateSimpleFilter()
      })
    },
    async getPromoteur (pk) {
      try {
        let { data } = await this.$api.getOne(this.$resources.ACCOUNT, pk)
        let promoteur = Object.assign({}, data)
        return promoteur
      } catch (err) {
        console.log(err)
        return null
      }
    },
    async getAllPrograms (query) {
      this.loadingFilters = true
      let params = { name: query }
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM, params)
        this.allPrograms = data.items
        this.loadingFilters = false
      } catch (e) {
        console.log(e)
        this.loadingFilters = false
        this.$toasted.global.danger('Erreur lors de la récupération des programmes !')
      }
    },
    updateDateLivraisonFilter (e) {
      if (!e) e = []
      if (!Array.isArray(e)) {
        e = [e]
      }
      let dates = []
      if (e.length) {
        e.forEach(y => {
          if (y && y.value) {
            y.value.forEach(x => dates.push(Number(x)))
          } else dates.push(y)
        })
      }
      this.$set(this, 'dateLivraisonFilter', e)
      this.$set(this.filters, 'date_livraison', dates)
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    },
    updateActabilityFilter: debounce(function () {
      if (this.actability) {
        let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
        let date = new Date()
        let currentTrim = trim.findIndex(x => x.includes(date.getMonth())) + 1
        this.$set(this.filters, 'date_actabilite__lt', `${date.getFullYear()}${currentTrim}`)
        this.$set(this.filters, 'date_actabilite__gt', 0)
        this.actability = true
        this.$nextTick(() => {
          this.updateSimpleFilter()
        })
      } else {
        this.$set(this.filters, 'date_actabilite__lt', null)
        this.$set(this.filters, 'date_actabilite__gt', null)
        this.actability = false
        this.$nextTick(() => {
          this.updateSimpleFilter()
        })
      }
      this.focus('#actability')
    }, 200),
    updateSalePriceFilter: debounce(function (e) {
      this.$set(this.filters, 'sale_price_ttc__gte', e[0])
      this.$set(this.filters, 'sale_price_ttc__lte', e[1])
      this.salePriceFilter = [e[0], e[1]]
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    }),
    updateSurfaceFilter: debounce(function (e) {
      this.$set(this.filters, 'surface__gte', e[0])
      this.$set(this.filters, 'surface__lte', e[1])
      this.surfaceFilter = [e[0], e[1]]
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    }),
    updateStatesFilter: debounce(function (e) {
      if (e && !Array.isArray(e)) e = [e]
      this.$set(this.filters, 'state_code', e)
      this.statesFilter = e
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    }),
    updateAnnexesFilter (e) {
      if (!Array.isArray(e)) e = [e]
      let annexValues = e.map(x => x.value)
      if (annexValues.includes('parking') && !annexValues.includes('parking_ext') && !annexValues.includes('parking_int')) {
        e.push({ label: 'Parking Ext.', value: 'parking_ext' })
        e.push({ label: 'Parking Int.', value: 'parking_int' })
      }
      this.$set(this.filters, 'annex_type', e)
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    },
    deleteAnnexesFilter: debounce(function (i) {
      if (Array.isArray(this.filters.annex_type)) {
        this.filters.annex_type.splice(i, 1)
      } else {
        this.$set(this.filters, 'annex_type', [])
      }
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    }, 200),
    deleteFiltersFromTags (filters, key) {
      if (key === 'lot_type') {
        this.updateSimpleFilter()
      }
      if (key === 'state_code') {
        this.updateStatesFilter(filters.state_code)
      }
      if (key === 'date_livraison') {
        this.updateDateLivraisonFilter(filters.date_livraison)
      }
      if (key === 'date_livraison__lte') {
        this.updateDateLivraisonFilter(filters.date_livraison__lte)
      }
      if (['surface__gte', 'surface__lte'].includes(key)) {
        this.updateSurfaceFilter([filters.surface__gte, filters.surface__lte])
      }
      if (['date_actabilite__gt', 'date_actabilite__lt'].includes(key)) {
        this.actability = false
        this.updateActabilityFilter()
      }
      if (['sale_price_ttc__gte', 'sale_price_ttc__lte'].includes(key)) {
        this.updateSalePriceFilter([filters.sale_price_ttc__gte, filters.sale_price_ttc__lte])
      }
      this.filters = filters
      this.$nextTick(() => {
        this.updateSimpleFilter()
      })
    },
    // clear focus on checkbox and radio
    focus (element) {
      document.querySelector(element).blur()
    }
  }
}
